import create from 'zustand';

export type PassbookStore = {
  metalTransactions: any;
  walletTransactions: any;
  barAllocationInvoice: any;
};

export const passbookStore = create<PassbookStore>((set) => ({
  metalTransactions: [],
  walletTransactions: [],
  barAllocationInvoice:[],
  setMetalTransactions: (metalTransactions: any) => set({ metalTransactions }),
  setWalletTransactions: (walletTransactions: any) =>
    set({ walletTransactions }),
  setBarAllocationInvoice: (barAllocationInvoice: any) => set({ barAllocationInvoice }),

  clearPassbook: () => set({ metalTransactions: [], walletTransactions: [], barAllocationInvoice:[] }),
}));